import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { resolveUrl } from "@/lib/api";

export const Lightbox = ({ items, index, onClose, onNav }) => {
  const item = items[index];

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav((index + 1) % items.length);
      if (e.key === "ArrowLeft") onNav((index - 1 + items.length) % items.length);
    },
    [index, items.length, onClose, onNav]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [handleKey]);

  if (!item) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center" data-testid="lightbox">
      <button onClick={onClose} data-testid="lightbox-close" className="absolute top-5 right-5 z-10 p-3 text-white/70 hover:text-amber-500 transition-colors">
        <X className="w-7 h-7" />
      </button>
      <button
        onClick={() => onNav((index - 1 + items.length) % items.length)}
        data-testid="lightbox-prev"
        className="absolute left-3 sm:left-8 z-10 p-3 text-white/60 hover:text-amber-500 transition-colors"
      >
        <ChevronLeft className="w-8 h-8" />
      </button>
      <button
        onClick={() => onNav((index + 1) % items.length)}
        data-testid="lightbox-next"
        className="absolute right-3 sm:right-8 z-10 p-3 text-white/60 hover:text-amber-500 transition-colors"
      >
        <ChevronRight className="w-8 h-8" />
      </button>
      <div className="max-w-6xl max-h-[85vh] px-6" onClick={(e) => e.stopPropagation()}>
        <img src={resolveUrl(item.image)} alt={item.title} className="max-h-[75vh] w-auto mx-auto object-contain rounded-lg" />
        <div className="mt-4 text-center">
          {item.category && <div className="font-mono text-xs uppercase tracking-widest text-amber-500">{item.category}</div>}
          {item.title && <div className="mt-1 font-display text-2xl font-bold uppercase text-white">{item.title}</div>}
          <div className="mt-1 font-mono text-xs text-white/40">
            {index + 1} / {items.length}
          </div>
        </div>
      </div>
    </div>
  );
};
